import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

const UniversalVariable = ({ universalVariable }) => (
  <Helmet
    script={[
      {
        innerHTML: `window.universal_variable=${JSON.stringify(
          universalVariable
        )}`,
      },
    ]}
  />
);

UniversalVariable.propTypes = {
  universalVariable: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const version = '1.0.0';
  const currency = state.app.config.currency;
  const page = {
    brand: 'Bravissimo',
    category: ownProps.pageType,
    environment: state.app.config.environment,
  };
  const universalVariable = { page, version };

  const getBagVariable = bag => ({
    currency,
    lineItems: bag.items.map(item => ({
      product: {
        brand: item.brandName,
        category: '', // TODO expose this data
        imageUrl: item.imgUrl,
        name: `${item.styleName} ${item.colour}`,
        other: 'Bravissimo',
        skuCode: item.skuCode,
        unitPrice: item.originalPrice,
        unitSalePrice: item.price,
        url: '', // TODO expose this data
      },
      quantity: item.quantity,
      subtotal: item.price * item.quantity,
    })),
    subtotal: bag.subTotal,
    subtotalIncludeTax: true,
    tax: bag.items.reduce(
      (total, product) =>
        total + product.quantity * (product.price - product.netPrice),
      0
    ),
    total: bag.total,
  });

  if (state.bag.itemCount) {
    universalVariable.basket = getBagVariable(state.bag);
  }

  if (state.product.selectedStyleColour) {
    const { data } = state.product.styleColour;
    if (data) {
      universalVariable.product = {
        category: '', // TODO expose this data
        colour: data.colour.colour,
        currency,
        id: data.styleColourCode,
        linkedProducts: [],
        manufacturer: data.brand,
        name: data.styleColourName,
        unitPrice: data.prices.originalPrice,
        unitSalePrice: data.prices.price,
      };
    }
  }

  if (state.checkout && state.checkout.confirmed && state.checkout.orderNo) {
    const bag = state.checkout.confirmed.bag;
    const orderNo = state.checkout.orderNo;
    universalVariable.transaction = {
      ...getBagVariable(bag),
      orderNo,
      shippingCost: bag.delivery.postage,
      shippingMethod: bag.delivery.methodLabel,
    };
  }

  if (state.auth.isAuthenticated) {
    const { user } = state.auth;
    if (user) {
      universalVariable.user = {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        returning: true,
        userId: user.id,
      };
    }
  }

  return { universalVariable };
};

export default connect(mapStateToProps)(UniversalVariable);
